import { FC, useContext } from 'react'
import { Button, Icon } from '@components/Generic'
import { observer } from 'mobx-react'
import { StoreContext } from '@store/Root.store'
import './Addons.css'

export const ExternalZoomControls: FC = observer(() => {
  const store = useContext(StoreContext)
  const { zoomButtons } = store.TranslationsState.translations

  return (
    <div className="pdf-addons__external-zoom-control-wrap">
      <Button
        onClick={() => store.PdfViewerState.zoomOut()}
        className="button--pdf-zoom"
        aria-label={zoomButtons.zoomOut}
      >
        <Icon type="zoom-out" size="30px" />
      </Button>

      <Button
        onClick={() => store.PdfViewerState.zoomIn()}
        className="button--pdf-zoom"
        aria-label={zoomButtons.zoomIn}
      >
        <Icon type="zoom-in" size="30px" />
      </Button>
    </div>
  )
})
